import React from "react";
import { useParams } from "react-router-dom";

import FlagsPage from "cortex/ui/src/fleet/view/flags/FlagsPage";
import { useAppDispatch, useAppSelector } from "cortex/ui/src/hooks";
import { Network } from "cortex/ui/src/network/model";
import { createPromiseApiAction } from "cortex/ui/src/redux-store/api-sagas";
import { getAuthUser } from "cortex/ui/src/redux-store/auth/selectors";
import { EDIT_NETWORK_FLAGS } from "cortex/ui/src/redux-store/networks/actions";
import {
  networksSelector,
  networksStoresLoadedSelector,
} from "cortex/ui/src/redux-store/networks/selectors";
import { isReadonly } from "cortex/ui/src/redux-store/users/selectors";

export default function NetworkFlagsPage() {
  const { id } = useParams<{ id: string }>();
  const dispatch = useAppDispatch();
  const storesLoaded = useAppSelector(networksStoresLoadedSelector);
  const networks = useAppSelector(networksSelector);
  const network = (networks[id] as Network | undefined) ?? null;
  const user = useAppSelector(getAuthUser);
  const readonly = isReadonly(user);

  return (
    <FlagsPage
      model={network}
      readonly={readonly}
      storesLoaded={storesLoaded}
      type="network"
      updateFlags={(serviceArgs: {
        id: string | number;
        flags: Record<string, string>;
      }) => {
        return createPromiseApiAction(dispatch, EDIT_NETWORK_FLAGS, [
          serviceArgs.id,
          serviceArgs.flags,
        ]);
      }}
    />
  );
}
